import { FileUploader } from "src/Components/Upload/FileUploader";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { showGlobalConfirmBox } from "src/Route/RootMiddleware";
import { Window } from "@progress/kendo-react-dialogs";
import classnames from 'classnames/bind';
import { useEffect, useState } from "react";
import service from "src/HomePage/MergePDF/MergePDF.service"

export const MergePDFWindow = (props) => {
    const {
        onCloseWindow
    } = props
    const [files, setFiles] = useState([])
    const [fileValid, setFileValid] = useState(false)
    /**最大合併檔案數量 */
    const maxFileMergeCount = 20;

    const closeConfirm = () => {
        showGlobalConfirmBox("是否關閉視窗? 關閉後檔案不會保留", async () => {

            onCloseWindow();
        }, {});
    }

    const handleSubmit = async () => {
        await service.importMultiPDF(files);
    }

    useEffect(() => {
        let isValid = true;
        if (files.length > 0) {
            files.forEach(file => {
                if (file.extension !== '.pdf' || file.size > 10485759) {
                    isValid = false;
                }
            })
            isValid ? setFileValid(true) : setFileValid(false);
        }
        else {
            setFileValid(false);
        }

        if (files.length > maxFileMergeCount) {
            showGlobalConfirmBox("超過最大上傳數量，請調整附件數量");
            setFileValid(false);
        }

    }, [files])

    const wrapperClassNames = classnames("custom-upload-wrapper",
        "custom-upload")

    return (
        <Window
            title={'附件合併'}
            initialWidth={window.screen.availWidth * 0.5}
            initialHeight={window.screen.availHeight * 0.6}
            onClose={closeConfirm}
            modal={true}
            resizable={false}
        >
            <div className={wrapperClassNames}>
                <div style={{ position: "absolute", textAlign: "left", alignSelf: "center", marginTop: "60px", zIndex: 10 }}>
                    <div className="upload-title" style={{ display: "flex" }}>
                        <b>上傳附件</b>
                        <Tooltip
                            content={() => (
                                <span style={{ fontSize: '15px' }}>
                                    {"1.上傳檔案格式請使用pdf 2.檔案請勿設定加密或保全 3.單一檔案上限請勿超過10MB"}
                                </span>
                            )}
                            openDelay={10}
                            position={"right"}
                            anchorElement="target"
                        >
                            <span
                                title={"1"}
                                style={{ verticalAlign: 'middle' }}
                                className="fa-exclamation-circle_RoyalBlue"
                            ></span>
                        </Tooltip>
                    </div>
                    <div className="upload-desc">至多選取{maxFileMergeCount}個附件，單一檔案不得超過10MB</div>
                </div>
                <FileUploader
                    multiple={true}
                    autoUpload={false}
                    maxFileSize={10485760} // 10MB
                    allowedExtensions={[".pdf"]}
                    files={files}
                    setFiles={setFiles}
                    style={{ position: "absolute" }}
                />
            </div>
            <div>
                最大數量: {maxFileMergeCount}<br />
                <div
                    style={{
                        color: files.length > maxFileMergeCount ? "red" : "inherit"
                    }}
                >目前數量: {files.length}</div>
            </div>
            {/* 按鈕區固定在底部 */}
            <div className="modal-footer row" style={{ flexShrink: 0 }}>
                <div className="text-center flex">
                    <button
                        type="button"
                        className="btn_secondary btn_sm col-6"
                        data-bs-dismiss="modal"
                        onClick={closeConfirm}
                    >
                        關閉
                    </button>
                    <button
                        disabled={!fileValid}
                        onClick={handleSubmit}
                        className="btn_primary btn_sm col-6"
                    >
                        合併
                    </button>
                </div>
            </div>
        </Window>
    )
}